<!-- 空白页 -->
<template>
  <div>
    <pc v-if="pageType === 'pc'"></pc>
    <mobile v-if="pageType === 'mobile'"></mobile>
  </div>
</template>

<script>
  (function() {
    if (document.documentElement.clientWidth > 960) {
      
      // 22222222
      // var hm = document.createElement("script");
      // hm.src = "https://hm.baidu.com/hm.js?7c776de221151da059e4b4bd67d03cbb";
      // var s = document.getElementsByTagName("script")[0]; 
      // s.parentNode.insertBefore(hm, s);
    }
  })();
export default {
  name: "detection",
  data() {
    return {
      pageType: 'pc'
    }
  },
  components: {
    pc: () => import("./pc"),
    mobile: () => import("./mobile"),
  },
  beforeMount() {
    const width = document.documentElement.clientWidth;
    if(width < 934) {
      this.pageType = 'mobile'
    } else {
      this.pageType = 'pc'

    }
  }
};
</script>

<style scoped></style>
